import { makeStyles } from "@material-ui/core/styles";
import styled from "@emotion/styled";
import { BASE_COLORS } from "../../../emotion-theme";

export const useListingTableStyles = makeStyles(() => ({
  headerRow: {
    "& th": {
      padding: "62px 12px 32px",
    },
  },
  noResults: {
    "text-align": "center",
    color: "#b7b7b7",
    background: "#e9e9e9",
    padding: "32px 12px",
  },
  tableContainer: {
    margin: "20px 0",
  },
  row: {
    "&:hover": {
      border: "solid 1.5px skyBlue",
      background: "#e0f5ff",
    },
    "&:focus": {
      border: `solid 1.5px ${BASE_COLORS.navyBlue}`,
    },
    "& th": {
      "& div": {
        "font-weight": "700",
      },
    },
  },
  rowCell: {
    padding: "12px",
  },
  rowPointer: {
    cursor: "pointer",
  },
  rowText: {
    "font-size": "small",
  },
}));

export const TableHeaderText = styled.span`
  font-size: 1.15rem;
`;
